import React from 'react'

import {
  FollowDropdown,
  FollowDropdownAction,
  FollowDropdownBellIcon,
  FollowDropdownChevronIcon,
  FollowDropdownContent,
  FollowDropdownDescription,
  FollowDropdownDivider,
  FollowDropdownLabel,
  FollowDropdownTrigger,
} from './SubscriptionToggle.styles'

import { Status, ArtboardToggleProps } from './types'

import { useUpdateNotification } from './operations'

//-----------------------------------------------------------------------------
// CONSTANTS

export const labels: Partial<{ [key in Status]: string }> = {
  ON: 'Following this Artboard',
  OFF: 'Not following this Artboard',
  PARTIAL: 'Following some threads',
}

export const actions: Partial<{ [key in Status]: string }> = {
  ON: 'Follow this Artboard',
  OFF: 'Stop Following this Artboard',
  PARTIAL: 'Following some threads',
}

export const descriptions: Partial<{ [key in Status]: string }> = {
  ON: 'You will receive notifications for all comments on this Artboard.',
  OFF: 'You will not receive any notifications for this Artboard.',
  PARTIAL: 'You will only receive notifications for some threads.',
}

//-----------------------------------------------------------------------------
// COMPONENTS

export const ArtboardSubscriptionToggle: React.FC<ArtboardToggleProps> = ({
  status,
  id,
  permanentArtboardShortId,
  documentVersionShortId,
  shareIdentifier,
}) => {
  const { updateArtboardNotification } = useUpdateNotification()

  const handleOn = () => {
    updateArtboardNotification({
      id,
      permanentArtboardShortId,
      documentVersionShortId,
      shareIdentifier,
      status: 'ON',
    })
  }

  const handleOff = () => {
    updateArtboardNotification({
      id,
      permanentArtboardShortId,
      documentVersionShortId,
      shareIdentifier,
      status: 'OFF',
    })
  }

  return (
    <FollowDropdown
      test-id="follow-dropdown"
      toggle={
        <FollowDropdownTrigger>
          <FollowDropdownBellIcon status={status} />
          <FollowDropdownLabel>{labels[status]}</FollowDropdownLabel>
          <FollowDropdownChevronIcon />
        </FollowDropdownTrigger>
      }>
      <FollowDropdownContent>
        <FollowDropdownDescription>
          {descriptions[status]}
        </FollowDropdownDescription>
        <FollowDropdownDivider />
        {status !== 'ON' && (
          <FollowDropdownAction onClick={handleOn}>
            {actions.ON}
          </FollowDropdownAction>
        )}
        {status !== 'OFF' && (
          <FollowDropdownAction onClick={handleOff}>
            {actions.OFF}
          </FollowDropdownAction>
        )}
      </FollowDropdownContent>
    </FollowDropdown>
  )
}
